import styles from "./LocationCard.module.css";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import PencilIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PencilIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

interface LocationCardProps {
  title: string;
  subtitle?: string | undefined;
  location: string;
  type: "pickup" | "refill";
}

export const LocationCard = ({
  title,
  subtitle,
  location,
  type,
}: LocationCardProps) => {
  return (
    <div className={`${styles["locationCard"]} ${styles[type]}`}>
      <div className={styles["textWrapper"]}>
        <FixaText textStyle="Body.S" className={styles[type]}>
          {title}
        </FixaText>
        {subtitle && (
          <FixaText textStyle="Label.XS" className={styles["subtitle"]}>
            {subtitle}
          </FixaText>
        )}
        <FixaText
          textStyle="HeadingRegular.XS"
          className={`${styles["location"]} ${styles[type]}`}
        >
          {location}
        </FixaText>
      </div>
      <FixaSSRIcon paths={PencilIconPath} className={styles["icon"]} />
    </div>
  );
};
